"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withPopupArea = exports.PopupArea = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireWildcard(require("@material-ui/core/withWidth"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PopupAreaContext = /*#__PURE__*/_react["default"].createContext({
  content: null,
  setContent: function setContent() {
    return undefined;
  },
  dismiss: function dismiss() {
    return undefined;
  }
});
var styles = function styles(theme) {
  var _defaultWrapper, _portalWrapper;
  return {
    defaultWrapper: (_defaultWrapper = {
      flex: 1,
      flexDirection: 'inherit',
      display: 'inherit',
      '&[data-state=hidden]': {
        maxHeight: 0,
        overflow: 'hidden',
        visibility: 'hidden'
      },
      '& > *': {
        pointerEvents: 'all' // needed to catch the pointer events again
      }
    }, _defineProperty(_defaultWrapper, theme.breakpoints.up('md'), {
      marginTop: '16px 16px 16px 0'
    }), _defineProperty(_defaultWrapper, theme.breakpoints.up('sm'), {
      marginTop: 8
    }), _defaultWrapper),
    portalWrapper: (_portalWrapper = {
      position: 'absolute',
      background: '#ffffff',
      top: 0,
      left: 0,
      bottom: 0,
      zIndex: 1
    }, _defineProperty(_portalWrapper, theme.breakpoints.down('xs'), {
      zIndex: 5 // Used 5 inorder to have higher zIndex value than viewsContainer which contains preview button in FullScreenView
    }), _defineProperty(_portalWrapper, '& div', {}), _portalWrapper)
  };
};
var PopupAreaProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(PopupAreaProvider, _React$Component);
  var _super = _createSuper(PopupAreaProvider);
  function PopupAreaProvider() {
    var _this;
    _classCallCheck(this, PopupAreaProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      content: null,
      options: {
        hideChildren: false
      },
      setContent: function setContent(content, options) {
        return _this.setState({
          content: content,
          options: options
        });
      },
      dismiss: function dismiss() {
        return _this.setState({
          content: null,
          options: {}
        });
      }
    });
    return _this;
  }
  _createClass(PopupAreaProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        width = _this$props.width,
        isPortalBreakPoint = _this$props.isPortalBreakPoint;
      var _this$state = this.state,
        content = _this$state.content,
        hideChildren = _this$state.options.hideChildren;
      return /*#__PURE__*/_react["default"].createElement(PopupAreaContext.Provider, {
        value: this.state
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.defaultWrapper,
        "data-state": content && hideChildren ? 'hidden' : 'show'
      }, this.props.children), content && (isPortalBreakPoint(width) ? /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.portalWrapper
      }, content), document.getElementById('frame')) : content));
    }
  }]);
  return PopupAreaProvider;
}(_react["default"].Component);
_defineProperty(PopupAreaProvider, "defaultProps", {
  isPortalBreakPoint: function isPortalBreakPoint(width) {
    return (0, _withWidth.isWidthDown)('sm', width);
  }
});
var PopupArea = exports.PopupArea = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'PopupArea'
})(PopupAreaProvider));
var withPopupArea = exports.withPopupArea = function withPopupArea(Component) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(PopupAreaContext.Consumer, null, function (state) {
      return /*#__PURE__*/_react["default"].createElement(Component, _extends({
        popupArea: state
      }, props));
    });
  };
};